/**
 * User: WangMeng
 * Date: 2018-07-17
 * Time: 17:45
 * Desc: 商誉较大
 */

import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';
import { fieldAnomaly } from '../../../../../utils/formatter';

export default class GoodwillChangeAnomaly extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '商誉';
    }

    getColumns = () => {
        return [{
            title: '商誉减值',
            dataIndex: 'goodwillImpair',
            render: val => val ? fieldAnomaly(val) + '元' : fieldAnomaly(val)
        }, {
            title: '商誉减值占商誉比重',
            dataIndex: 'goodwillImpairtogoodwill',
            render: val => fieldAnomaly(val)
        }, {
            title: '商誉较上年增减',
            dataIndex: 'goodwillVola',
            render: val => val ? fieldAnomaly(val) + '%' : fieldAnomaly(val)
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/danger/GoodwillChangeAnomaly.jsx